<template>
  <div class="field-control">
    <el-form :model="control" label-width="70px">
      <el-form-item prop="name">
        <template slot="label">
          <span class="require-flag">*</span>
          名称
        </template>
        <el-input v-model="control.name"></el-input>
      </el-form-item>
      <el-form-item prop="refCid">
        <template slot="label">
          <span class="require-flag">*</span>
          关联表字段
        </template>
        <div class="flexRow">
          <el-select v-model="control.refCid" placeholder="请选择" @change="control.field = ''">
            <el-option
              v-for="item in refFields"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-tooltip class="item" effect="dark" placement="bottom">
            <div slot="content">
              1、新添加的关联表保存后才可选择；
              <br />
              2、所选的关联表字段配置若发生变化，
              <br />
              则这里会被清空。
            </div>
            <span style="margin-left: 6px; line-height: 40px; font-size: 20px; color: #bdbdbd">
              <i class="el-icon-question"></i>
            </span>
          </el-tooltip>
        </div>
      </el-form-item>
      <el-form-item prop="field">
        <template slot="label">
          <span class="require-flag">*</span>
          显示字段
        </template>
        <el-select
          v-model="control.field"
          placeholder="请选择"
          no-data-text="请先选择一个关联表字段"
          filterable
          @change="changeMain"
        >
          <el-option
            v-for="item in refFieldCanShow"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="description">
        <template slot="label">
          描述
        </template>
        <el-input v-model="control.description"></el-input>
      </el-form-item>
      <el-form-item prop="required">
        <template slot="label">
          必填
        </template>
        <el-checkbox v-model="control.required" :disabled="control.main"></el-checkbox>
      </el-form-item>
      <el-form-item prop="display">
        <template slot="label">
          显示
        </template>
        <el-checkbox v-model="control.display" :disabled="control.main"></el-checkbox>
      </el-form-item>
      <el-form-item prop="disabled">
        <template slot="label">
          不可编辑
        </template>
        <el-checkbox v-model="control.disabled"></el-checkbox>
      </el-form-item>
      <el-form-item
        prop="main"
        v-if="!['file', 'ref', 'rich'].includes(refFieldTypeMap[control.field])"
      >
        <template slot="label">
          标题
        </template>
        <el-checkbox v-model="control.main" @change="checkChange($event)"></el-checkbox>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { getSheetInAvailableSheets } from "@/utils/sheet"

export default {
  name: "field-control",
  props: {
    control: Object,
    fields: Array,
    availableSheets: Array
  },
  computed: {
    // [工作表字段]当前工作表视图的字段里的关联单条 “关联表” 字段(type=ref,oneFlag=true)
    refFields() {
      return this.fields.reduce((acc, control) => {
        if (control._type === "ref" && control.oneFlag)
          acc.push({
            label: control.name,
            value: control._cid,
            fields: control.fields,
            refSheetId: control.refSheetId
          })
        return acc
      }, [])
    },
    // [工作表字段]当前关联表字段可展示的字段
    refFieldCanShow() {
      let cid = this.control.refCid
      if (!cid || this.refFields.length === 0) return []
      let refField = this.refFields.find(i => i.value === cid)
      let sheet = getSheetInAvailableSheets(this.availableSheets, refField.refSheetId)
      if (Object.keys(sheet).length == 0) return []
      return sheet.controls.map(c => ({ label: c.name, value: c._cid }))
    },
    refFieldTypeMap() {
      let cid = this.control.refCid
      if (!cid || this.refFields.length === 0) return {}
      let refField = this.refFields.find(i => i.value === cid)
      let sheet = getSheetInAvailableSheets(this.availableSheets, refField.refSheetId)
      if (Object.keys(sheet).length == 0) return {}
      return sheet.controls.reduce((acc, cur) => ((acc[cur._cid] = cur._type), acc), {})
    }
  },
  methods: {
    checkChange(value) {
      this.$emit("checkboxChange", "main", value)
    },
    changeMain(value) {
      if (["file", "ref", "rich"].includes(this.refFieldTypeMap[value])) {
        this.control.main = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.field-control {
  .el-form {
    padding: 12px 12px 0 0;
  }
}
</style>
